import gql from 'graphql-tag'

export const DELETE_PROPERTY_MUTATION = gql`
  mutation DeleteProperty (
    $id: Int!
  ){
    deleteProperty(
      data: {
        id: $id
      }
    ) {
      id
    }
  }
`
